import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { SelectField } from 'src/jbc-front/components/Form';
import { getSelectOptions } from 'src/reducers/selectOptions';
import selector from 'src/utils/Utils';
import { getAllowanceFormValues } from 'src/reducers/clients/allowances';
import TargetSettings from './TargetSettings';
import BaseSalaryFormulaSettings from './BaseSalaryFormulaSettings';

const AllowancePaymentIndividual = ({ selectedFormulaOrderType, roundingOption, payrollRulesGroup, formulaOrderType }) => {
  const { t } = useTranslation();
  return (
    <div>
      <TargetSettings allowanceType="payment" />
      {(payrollRulesGroup.payrollType === 'daily' || payrollRulesGroup.payrollType === 'hourly') &&
        formulaOrderType === 'base_salary' && <BaseSalaryFormulaSettings />}
      {selectedFormulaOrderType === 'base_salary' && (
        <SelectField
          required
          name="roundingOption"
          label={t('features.ClientUnitPrices.containers.ClientUnitPriceForm.Rounding')}
          options={roundingOption}
        />
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  selectedFormulaOrderType: selector(getAllowanceFormValues(state), 'formulaOrderType'),
  roundingOption: getSelectOptions(state, 'clientAllowanceRounding'),
  formulaOrderType: selector(getAllowanceFormValues(state), 'formulaOrderType')
});

export default connect(mapStateToProps)(AllowancePaymentIndividual);
